<div class="container-fluid">
  <div class="invoiceWrapper">
    <div class="row">
      <div class="col-lg-1"> </div>
      <div class="col-lg-10">
        <div class="card">
          <div class="card-body">
            <div class="headerWrapper">
              <h4> Users</h4>
              <div class="buttonWrapper">
                <button *ngIf="addPermission === true"  class="btn btn-success btn-sm" mat-raised-button (click)="openDialog()">
                  <i class="fa fa-plus" aria-hidden="true" ></i>ADD NEW</button>
                <button *ngIf="editPermission === true" class="btn btn-warning btn-sm" (click)="editDialog(selectedIndex, 'edit')">
                  <i class="fa fa-pencil-square-o" aria-hidden="true"></i>EDIT</button>
                <button *ngIf="editPermission === true" class="btn btn-primary btn-sm" (click)="editDialog(selectedIndex, 'password')">
                  <i class="fa fa-pencil-square-o"aria-hidden="true"></i>UPDATE PASSWORD</button>
                <button *ngIf="deletePermission === true" class="btn btn-danger btn-sm" (click)="deleteDialog(selectedIndex)">
                  <i class="fa fa-trash" aria-hidden="true"></i>DELETE</button>
              </div>
            </div>
            <div class="customModal">
            </div>
            <table class="table table-bordered" *ngIf="viewPermission === true">
              <thead>
              <tr>
                <th scope="col1">First Name</th>
                <th scope="col2">Last Name</th>
                <th scope="col3">Email</th>
                <th scope="col4">Username</th>
                <th scope="col5">Role</th>
              </tr>
              </thead>
              <tbody>
                  <tr rowspan=""
                  *ngFor="let in of users | paginate: { id: 'stockPageId', itemsPerPage: per_page, currentPage: current_page, totalItems: total_count}; let i = index "
                  (click)="selectRow(i)" [ngClass]="{'sel': i === selectedIndex }"
                  (dblclick)="openEditDialog(selectedIndex)" style="height: 36px;">
                <td class="col1">{{in.first_name}}</td>
                <td class="col2">{{in.last_name}}</td>
                <td class="col3">{{in.email}}</td>
                <td class="col4">{{in.username}}</td>
                <td class="col5">{{in.role}}</td>
              </tr>
              </tbody>
            </table>
            <div class="footerWrapper row">
              <div class="col-lg-7 col-md-12 col-sm-12">
                <div class="input-group">
                  <select name="searchBy" [(ngModel)]="searchBy" data-show-content="true"
                          class="form-control border" (change)="getSearchValue()">
                    <option name="userFirstName" value="0"> Search by First Name</option>
                    <option name="userLastName"  value="1"> Search by Last Name</option>
                    <option name="userEmail"     value="2">Search by Email</option>
                    <option name="userUserName"  value="3"> Search by User Name</option>
                    <option name="userRole"      value="4"> Search by Role</option>
                  </select>
                    <input type="text" placeholder="Search" class="form-control"
                           name="searchTxt" [(ngModel)]="searchTxt" [placeholder]="placeHolder">

                    <span class="input-group-text" (click)="doSearch()">
                        <i class="fa fa-search" aria-hidden="true"></i>
                    </span>
                    <span class="input-group-text" (click)="doRefresh()">
                        <i class="fa fa-refresh" aria-hidden="true"></i>
                    </span>
                </div>
              </div>
              <div class="col-lg-5 col-md-12 col-sm-12">
                <app-common-page [id]="stockPageId" (pageChange)="doPaginate($event)">
                </app-common-page>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-1"> </div>
    </div>
  </div>
</div>
